<template>
  <div class="fox-invoice-create__wrapper">
    <div class="fox-invoice-create__container">
      <div class="tw-mb-10 tw-flex tw-items-start tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-6">
        <a href="#" @click.prevent="example" class="link-button">
          Beispiel-Brief
        </a>

        <div class="fox-invoice-action__container">
          <button @click="preview" class="fox-invoice-action__create-btn fox-invoice-action__create-btn--sky-blue tw-flex tw-items-center tw-shadow-lg">
            <FocusIcon />
            <span class="tw-text-black tw-font-bold">Vorschau</span>
          </button>
          <button @click="sendAsEnvelop" class="fox-invoice-action__create-btn fox-invoice-action__create-btn--green tw-flex tw-items-center">
            <LetterIcon />
            <span class="tw-text-white">als Brief Versenden</span>
          </button>
          <button @click="download" class="fox-invoice-action__create-btn fox-invoice-action__create-btn--default">
            <PdfIcon />
            <span class="tw-text-white">Download - PDF</span>
          </button>
        </div>
      </div>

      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4 lg:tw-gap-8">
        <div>
          <LetterSenderForm :sender="letter.sender" @update="updateSender" />

          <div class="tw-mt-5">
            <label class="fox-label--simple">
              Empfänger <span class="fox-input__require-star">*</span>
            </label>
            <textarea name="customer_address_plain"
                      rows="5"
                      class="fox-input--simple tw-w-full"
                      :placeholder=placeholder.recipient
                      v-bind:class="classes.recipient"
                      v-model="letter.recipient"></textarea>
          </div>
        </div>

        <div>
          <label class="fox-label--simple">
            Zusatzinformation
          </label>
          <textarea name="customer_address_plain"
                    rows="5"
                    class="fox-input--simple tw-w-full"
                    :placeholder=placeholder.extraInfo
                    v-model="letter.extraInfo"></textarea>
        </div>
      </div>

      <div class="fox-invoice-create__divider"></div>

      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 lg:tw-gap-8">
        <div>
          <label class="fox-label--simple">
            Title<span class="fox-input__require-star">*</span>
          </label>
          <input type="text"
                 class="fox-input--simple tw-w-full"
                 v-model="letter.title"
                 :placeholder="placeholder.title"
                 v-bind:class="classes.title"
          >
        </div>
      </div>

      <div class="fox-invoice-create__divider"></div>

      <div>
        <InvoiceRichTextInput @change="updateLetterText" :value="letter.text" :height="320"/>
      </div>

      <div class="fox-invoice-create__divider"></div>

      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 lg:tw-gap-6">
        <div class="tw-w-full">
          <label class="fox-label--simple">
            Fusszeile 1
          </label>
          <textarea name="customer_address_plain"
                    rows="5"
                    :placeholder="placeholder.footerFieldOne"
                    class="fox-input--simple tw-w-full"
                    v-model="letter.footerFieldOne"></textarea>
        </div>

        <div class="tw-w-full">
          <label class="fox-label--simple">
            Fusszeile 2
          </label>
          <textarea name="customer_address_plain"
                    rows="5"
                    :placeholder="placeholder.footerFieldTwo"
                    class="fox-input--simple tw-w-full"
                    v-model="letter.footerFieldTwo"></textarea>
        </div>

        <div class="tw-w-full">
          <label class="fox-label--simple">
            Fusszeile 3
          </label>
          <textarea name="customer_address_plain"
                    rows="5"
                    :placeholder="placeholder.footerFieldThree"
                    class="fox-input--simple tw-w-full"
                    v-model="letter.footerFieldThree"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import $ from 'jquery'
import { required } from '@vuelidate/validators'
import InvoiceRichTextInput from '@/components/Invoice/Create/InvoiceRichTextInput'
import letterTestingData from '@/test/data/letterData.json'
import LetterSenderForm from '@/components/Letter/Create/LetterSenderForm'
import LetterIcon from '@/components/Icon/LetterIcon.vue'
import PdfIcon from '@/components/Icon/PdfIcon.vue'
import FocusIcon from '@/components/Icon/FocusIcon.vue'

export default {
  components: { LetterSenderForm, InvoiceRichTextInput, LetterIcon, PdfIcon, FocusIcon },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      letter: {
        text: { required },
        recipient: { required },
        title: { required }
      }
    }
  },
  data: function () {
    return {
      letter: {
        sender: {
          name: null,
          street: null,
          postalCode: null,
          city: null
        },
        text: null,
        recipient: null,
        extraInfo: null,
        title: null,
        footerFieldOne: null,
        footerFieldTwo: null,
        footerFieldThree: null
      },
      placeholder: {
        text: '',
        recipient: 'Muster GmbH\nMusterstraße 62-66\n80636 München\nDeutschland',
        extraInfo: 'Datum: 11. Nov 2022\nAnsprechpartner: Dirk Heller\nTel: 151 5233 2132',
        title: 'Geschäftsbrief',
        footerFieldOne: 'Tel.: 154 1232 4923\nE-Mail: contact@max-mustermann.com\nWeb: www.max-mustermann.de',
        footerFieldTwo: 'USt.-ID: DE12345893\nInhaber/-in: Max Musterman',
        footerFieldThree: 'Berliner Volksbank\nIBAN: DE91100000000123456789\nBIC: BEVODEBB'
      }
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'development') {
      this.letter = letterTestingData
    }
  },
  computed: {
    classes: function () {
      return {
        text: {
          'fox-input--error': this.v$.letter.text.$error
        },
        recipient: {
          'fox-input--error': this.v$.letter.recipient.$error
        },
        title: {
          'fox-input--error': this.v$.letter.title.$error
        }
      }
    }
  },
  methods: {
    async preview () {
      const isFormCorrect = await this.v$.$validate()

      if (isFormCorrect) {
        this.$emit('preview', this.letter)
      } else {
        this.scrollToFirstError()
      }
    },
    async example () {
      this.$emit('example')
    },
    async download () {
      const isFormCorrect = await this.v$.$validate()

      if (isFormCorrect) {
        this.$emit('download', this.letter)
      } else {
        this.scrollToFirstError()
      }
    },
    async sendAsEnvelop () {
      const isFormCorrect = await this.v$.$validate()

      if (isFormCorrect) {
        this.$emit('sendAsEnvelope', this.letter)
      } else {
        this.scrollToFirstError()
      }
    },
    updateLetterText (text) {
      this.letter.text = text
    },
    updateSender (sender) {
      this.letter.sender = sender
    },
    scrollToFirstError () {
      $('html, body').animate({
        scrollTop: $('.fox-input--error:visible:first').offset().top
      }, 800)
    }
  }
}
</script>
